import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "date-picker" }
const _hoisted_2 = { class: "date-picker__name" }
const _hoisted_3 = { class: "date-picker__date" }
const _hoisted_4 = { class: "custom-select" }
const _hoisted_5 = {
  selected: "",
  disabled: ""
}
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "custom-select" }
const _hoisted_8 = {
  selected: "",
  disabled: ""
}
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "custom-select" }
const _hoisted_11 = {
  selected: "",
  disabled: ""
}
const _hoisted_12 = ["value"]

import {computed, reactive, watchEffect} from "vue";
import {useLocalization} from "@/utils/useLocalization";

const numberOfYears = 60


export default /*#__PURE__*/_defineComponent({
  __name: 'DateInput',
  props: {
    name: {},
    required: { type: Boolean }
  },
  emits: ["pick"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const {t} = useLocalization()

const date = reactive({
  year: new Date().getFullYear(),
  month: new Date().getMonth() + 1,
  day: new Date().getDate()
})

const months = [
  {
    name: 'Январь',
    number: 1
  },
  {
    name: 'Февраль',
    number: 2
  },
  {
    name: 'Март',
    number: 3
  },
  {
    name: 'Апрель',
    number: 4
  },
  {
    name: 'Май',
    number: 5
  },
  {
    name: 'Июнь',
    number: 6
  },
  {
    name: 'Июль',
    number: 7
  },
  {
    name: 'Август',
    number: 8
  },
  {
    name: 'Сентябрь',
    number: 9
  },
  {
    name: 'Октябрь',
    number: 10
  },
  {
    name: 'Ноябрь',
    number: 11
  },
  {
    name: 'Декабрь',
    number: 12
  },
]

const startingYear = new Date().getFullYear()
const days = computed(() => getMonthDays())
const getMonthDays = () => {
  const tmp = new Date(date.year, date.month - 1)
  tmp.setMonth(tmp.getMonth() + 1)
  tmp.setDate(0)
  return tmp.getDate()
}

watchEffect(() => {
  if (date.day > days.value) {
    date.day = 1
  }
  const datePicked = new Date(date.year, date.month - 1, date.day, 3)

  emit('pick', datePicked.toISOString().split('T')[0])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('Выберите дату рождения')) + ":", 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date.day) = $event))
        }, [
          _createElementVNode("option", _hoisted_5, _toDisplayString(_unref(t)('Выберите день')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: day
            }, _toDisplayString(day), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, date.day]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((date.month) = $event))
        }, [
          _createElementVNode("option", _hoisted_8, _toDisplayString(_unref(t)('Выберите месяц')), 1),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(months, (month, index) => {
            return _createElementVNode("option", {
              value: month.number,
              key: index
            }, _toDisplayString(_unref(t)(month.name) ?? month.name), 9, _hoisted_9)
          }), 64))
        ], 512), [
          [_vModelSelect, date.month]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((date.year) = $event))
        }, [
          _createElementVNode("option", _hoisted_11, _toDisplayString(_unref(t)('Выберите год')), 1),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(numberOfYears, (year, index) => {
            return _createElementVNode("option", {
              value: _unref(startingYear) - index,
              key: year
            }, _toDisplayString(_unref(startingYear) - (index)), 9, _hoisted_12)
          }), 64))
        ], 512), [
          [_vModelSelect, date.year]
        ])
      ])
    ])
  ]))
}
}

})